import React, { Component } from 'react';
import './App.css';


class AppEntry extends Component {

	constructor(title, icon, link) 
   { 
		super();
		this.appName = title;
		this.icon = icon;
		this.link = link;
	}
  
  render() {
    return (
      
        <li>
		<div>
		<img src={'img/' + this.icon} width="64" height="64"/>
		<a href={'https://play.google.com/store/apps/details?id=wagner.rainer.apps.' + this.link}>LINK</a> 
		</div>
		</li>
      
    );
  }
}

export default AppEntry;


// WEBPACK FOOTER //
// ./src/AppEntry.js